import { useDispatch } from "react-redux";
import { deleteCategory } from "../store/action";

import CategoriesEdit from "../components/CategoriesEdit";

function CategoriesTableRow({c, index}) {
    const dispatch = useDispatch()
    const handleDelete = (e) => {
        e.preventDefault()
        dispatch(deleteCategory(e.target.value))
      }

    return (
        <tr key={c.id}>
            <th scope="row">{index + 1}</th>
            <td>{c.name}</td>
            <td>{c.createdAt.toLocaleString().substring(0, 10)}</td>
            <td>{c.updatedAt.toLocaleString().substring(0, 10)}</td>
            <td>
                <button className="btn btn-danger" value={c.id} onClick={handleDelete}>Delete</button>
                <CategoriesEdit item={c}/>
            </td>
        </tr>
    )
}

export default CategoriesTableRow